var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C5.13401 3 2 6.19323 2 10.1323C2 14.0713 5.13401 17.2646 9 17.2646H12V19.0163C12 19.6791 12.6096 20.1637 13.2248 19.9481C16.7364 18.7172 22 15.5644 22 10.1323C22 6.19323 18.866 3 15 3H9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlt3);
export default __webpack_public_path__ + "static/media/chat-alt-3.bbdd2099a3fe750d52950ed02c0af30c.svg";
export { ForwardRef as ReactComponent };